import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//Import Icons
import FeatherIcon from "feather-icons-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootReducerState } from "src/store/reducers";
import { closeAllNotification, closeNotification, getNotification, getNotificationCount } from "src/store/notification/action";
import { ROUTER } from "src/constants/routes";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './transition.css';

const NotificationDropdown = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  const { notification , notificationClose,notificationCount} = useSelector((state: RootReducerState) => state.NotificationReducer);
  const [menu, setMenu] = useState(false);

  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(getNotificationCount())
  },[])

  useEffect(()=>{
    if(notificationClose){
      dispatch(getNotification())
      dispatch(getNotificationCount())
    }
  },[notificationClose])

  useEffect(()=>{
    if(menu){
      dispatch(getNotification())
    }
  },[menu])
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <FeatherIcon icon="bell" className="icon-lg" />
          <span className="badge rounded-pill bg-primary">{notificationCount > 0 ? notificationCount : ""}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                {/* <Link to="#" className="small">
                  {" "}
                  View All
                </Link> */}
              </div>
            </Row>
          </div>
          <SimpleBar  style={{padding:"10px 20px",width:"300px",height:notification?.length > 0 ? "500px" : "200px"}}>
            {notification?.length>0 ? 
            <TransitionGroup>
        {notification?.map((data:any,index:any)=>{
          return(
            <CSSTransition key={data.logId} timeout={300} classNames="fade">
          <div className="d-flex align-items-center" key={index}>
            <Link to={ROUTER.JOB_SHEETS_VIEW + "/" + data.jobId} className="text-reset notification-item" onClick={()=>{
              dispatch(closeNotification(data.logId))
              setMenu(false)
              }}>
              <div className="d-flex">
                {/* <div className="avatar-sm me-3">
                  <span className="avatar-title bg-primary rounded-circle font-size-16">
                    <i className="bx bx-cart" />
                  </span>
                </div> */}
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">
                    {data.jobNumber}
                  </h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                     {data.title}
                    </p>
                    {/* <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />{" "}
                      {props.t("3 min ago")}{" "}
                    </p> */}
                  </div>
                </div>
              </div>
            </Link>
              <div className="" style={{cursor:"pointer",fontWeight:"500"}} onClick={()=>dispatch(closeNotification(data.logId))}>X</div>
            </div>
            </CSSTransition>
          )
        }) }
        </TransitionGroup>
        : <div className="text-center">No notification found</div>}
        </SimpleBar>
       
          <div className="p-2 border-top d-flex justify-content-between">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to={ROUTER.NOTIFICATION_LIST}
              onClick={()=>setMenu(false)}
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              {props.t("View all")}{" "}
            </Link>
            <div
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              // onClick={()=>setMenu(false)}
              onClick={()=>{
                dispatch(closeAllNotification())
                setMenu(false)
              }}
            >
              <i className="mdi mdi-close-circle me-1"></i>{" "}
              {props.t("Clear all")}{" "}
            </div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};
